/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetSlackEvidenceReminder200ResponseInnerSettingsInnerRemindersInner
 */
export interface GetSlackEvidenceReminder200ResponseInnerSettingsInnerRemindersInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerSettingsInnerRemindersInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerSettingsInnerRemindersInner
     */
    'effectiveDayType': GetSlackEvidenceReminder200ResponseInnerSettingsInnerRemindersInnerEffectiveDayTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetSlackEvidenceReminder200ResponseInnerSettingsInnerRemindersInner
     */
    'effectiveDay': number;
    /**
     * 
     * @type {number}
     * @memberof GetSlackEvidenceReminder200ResponseInnerSettingsInnerRemindersInner
     */
    'effectiveHours': number;
    /**
     * 
     * @type {number}
     * @memberof GetSlackEvidenceReminder200ResponseInnerSettingsInnerRemindersInner
     */
    'effectiveMinutes': number;
}

export const GetSlackEvidenceReminder200ResponseInnerSettingsInnerRemindersInnerEffectiveDayTypeEnum = {
    number: 'NUMBER',
    endOfMonth: 'END_OF_MONTH'
} as const;

export type GetSlackEvidenceReminder200ResponseInnerSettingsInnerRemindersInnerEffectiveDayTypeEnum = typeof GetSlackEvidenceReminder200ResponseInnerSettingsInnerRemindersInnerEffectiveDayTypeEnum[keyof typeof GetSlackEvidenceReminder200ResponseInnerSettingsInnerRemindersInnerEffectiveDayTypeEnum];


